import React from 'react'
import { Button } from 'antd-mobile';
import { FormattedMessage } from 'react-intl';
import { formatMoney } from '../../components/common/utils'

import styles from '../PriceList/PriceList.module.css'

const getSelectedGoodsList = (data, submitItems) => {
  const goodsListArr = []
  data.map(goodsList => {
    goodsListArr.push(...goodsList.skus)
  })
  const selectedItemsList = submitItems.map(selectedItem => {
    let selectedGood = goodsListArr.find(
      item => item.skuId === selectedItem.skuId && item.goodsId === selectedItem.goodsId
    )
    selectedGood = {
      ...selectedGood,
      number: selectedItem.number
    }
    return selectedGood
  })
  return selectedItemsList
}

const getTotalPrice = (data, submitItems) => {
  //TODO
  const currency = 'CNY';
  const selectedGoodsList = getSelectedGoodsList(data, submitItems)
  let total = 0;
  for( let item of selectedGoodsList ) {
    total += item.price * item.number;
  }
  return formatMoney(total, currency, true);
}

const getTotalAmout = (data, submitItems) => {
  const selectedGoodsList = getSelectedGoodsList(data, submitItems)
  let amount = 0;
  for( let item of selectedGoodsList ) {
    amount += item.number
  }
  return amount
}

const CheckoutCounter = ({ toCheckout, disabled, amount, total }) => {
  return <div className={styles.checkout}>
    <div className={styles.price}>
      <div className={styles.checkout}>
        <span><FormattedMessage id="book-total" />{total}</span>
        <span className={styles.instructions}>
        <FormattedMessage id="book-checkout-hint" />
        </span>
      </div>
    </div>
    <div className={styles.pay}>
          <Button 
            type="primary" 
            className={styles.payBtn} 
            disabled={disabled}
            onClick={toCheckout}
          >
            <FormattedMessage id="book-checkout" />({amount})
          </Button>
      )
    </div>
  </div>
}

export default CheckoutCounter